import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"align":"center"}},[_c(VCol,{attrs:{"cols":"12"}},[_c('div',{staticClass:"body-1 font-weight-light pt-6 pt-md-0 text-center dashboard-footer-copy white--text"},[_vm._v(" "+_vm._s(_vm.getVersion())+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }